(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').controller('myDeviceController', MyDeviceController);

  MyDeviceController.$inject = ['$rootScope',
    '$window',
    'uteLocale',
    'uteModal',
    'env',
    'wirelessDashboardService',
    'lostStolenDeviceService'];

  function MyDeviceController($rootScope,
                              $window,
                              uteLocale,
                              uteModal,
                              env,
                              wirelessDashboardService,
                              lostStolenDeviceService) {
    var mdCtrl = this;
    var accessoryURL = '';
    init();

    function init() {
      mdCtrl.language = uteLocale.language;
      mdCtrl.isOwner = $rootScope.userInfo.profileType.owner;
      mdCtrl.isGroupId = $rootScope.userInfo.profileType.groupId;
      mdCtrl.isAccountHolder = !($rootScope.userInfo.profileType.subscriber);
      accessoryURL = (uteLocale.language === 'en') ? env.enFidoAccessory : env.frFidoAccessory;

      // we need to have same height for my device and my plan boxes
      wirelessDashboardService.myPlanBoxHeight()
        .then(function (height) {
          mdCtrl.headerHeight = height;
        });

      getDevice();
    }

    function getDevice() {
      wirelessDashboardService.getDevice(mdCtrl.selectedBan, mdCtrl.selectedCtn)
        .then(function (response) {
          var data = response.data;
          if (data.deviceDetails) {
            mdCtrl.voiceMailIndicator = data.deviceDetails.voiceMailIndicator;
            mdCtrl.productId = data.deviceDetails.deviceDetail.productId;
            mdCtrl.hupCTAText = mdCtrl.productId ===  'NON_FIDO' ? 'wireless.dashboard.myDevice.nonFidoDeviceUpgradeCta' : 'wireless.dashboard.myDevice.upgradeDeviceCTA' ;
            if (data.deviceDetails.deviceDetail) {
              mdCtrl.deviceDetail = (mdCtrl.language === 'en') ? data.deviceDetails.deviceDetail.en : data.deviceDetails.deviceDetail.fr;
              lostStolenDeviceService.setDeviceDetails(data.deviceDetails.deviceDetail);
            } else {
              mdCtrl.deviceDetail = null;
            }
          } else {
            mdCtrl.deviceDetail = null;
          }
          if (data.upgradeDeviceDetails) {
            mdCtrl.deviceUpgradeDetail = data.upgradeDeviceDetails;
            mdCtrl.formattedDate = new Date(mdCtrl.deviceUpgradeDetail.subsidyEndDate);
          } else {
            mdCtrl.deviceUpgradeDetail = null;
          }
        });
    }

    mdCtrl.saleStatuspopup = function () {
      uteModal.open({
        templateUrl: 'modules/my-account/salestatus-modal.html',
        windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
        backdrop: 'static',
        size: 'lg',
        windowClass: 'salestatus-modal_holder',
        controller: ['$scope', '$modalInstance', '$translate', function ($scope, $modalInstance, $translate) {
          $scope.salereserve = $translate.instant('wireless.message.liveChat.salestatus.sale_reserve');
          $scope.backorder = $translate.instant('wireless.message.liveChat.salestatus.backorder-cta');
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
        }]
      });
    };

    mdCtrl.fidoAccessory = function () {
      $window.open(accessoryURL, '_blank').focus();
    };
  }

})();
